function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { withUniqueId } from './UniqueId';
var Context = React.createContext('overlay');
export function withOverlay(options) {
  return function (Component) {
    var OverlayConsumer = /*#__PURE__*/function (_React$PureComponent) {
      _inheritsLoose(OverlayConsumer, _React$PureComponent);
      function OverlayConsumer() {
        var _this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
        _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function (usingEscapeKey) {
          if (_this.props.onRequestClose) {
            _this.props.onRequestClose(usingEscapeKey);
          }
        });
        return _this;
      }
      var _proto = OverlayConsumer.prototype;
      _proto.componentDidMount = function componentDidMount() {
        this.props.openById(this.props.id, this.props.freezeScroll);
      };
      _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this$props = this.props,
          freezeScroll = _this$props.freezeScroll,
          id = _this$props.id;
        if (prevProps.id !== id || prevProps.freezeScroll !== freezeScroll) {
          this.props.closeById(prevState.id, prevState.freezeScroll);
          this.props.openById(id, freezeScroll);
        }
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.closeById(this.props.id, this.props.freezeScroll);
      };
      _proto.render = function render() {
        var _this$props2 = this.props,
          closeById = _this$props2.closeById,
          forwardedRef = _this$props2.forwardedRef,
          freezeScroll = _this$props2.freezeScroll,
          id = _this$props2.id,
          openById = _this$props2.openById,
          props = _objectWithoutPropertiesLoose(_this$props2, ["closeById", "forwardedRef", "freezeScroll", "id", "openById"]);
        return React.createElement(Component, Object.assign({}, props, {
          id: id,
          onRequestClose: this.handleRequestClose,
          ref: forwardedRef
        }));
      };
      return OverlayConsumer;
    }(React.PureComponent);
    _defineProperty(OverlayConsumer, "defaultProps", {
      freezeScroll: false
    });
    process.env.NODE_ENV !== "production" ? OverlayConsumer.propTypes = {
      closeById: PropTypes.func.isRequired,
      forwardedRef: PropTypes.func,
      freezeScroll: PropTypes.bool,
      id: PropTypes.string,
      onRequestClose: PropTypes.func,
      openById: PropTypes.func.isRequired,
      overlayId: PropTypes.string.isRequired,
      overlayName: PropTypes.string.isRequired
    } : void 0;
    return withUniqueId(options || {})(
    // eslint-disable-next-line react/display-name,react/no-multi-comp
    React.forwardRef(function (props, ref) {
      return React.createElement(Context.Consumer, null, function (overlayProps) {
        return React.createElement(OverlayConsumer, Object.assign({}, props, overlayProps, {
          forwardedRef: ref
        }));
      });
    }));
  };
}
export default Context.Provider;